import React from "react";
import LayoutV1 from "markup/Layout/LayoutV1";
import "../../../css/messages.css";
import Chatrooms from "./Chatrooms";
import Messaging from "./Messaging";

function MessagingShell(props) {
  const activeId = props.match.params.id;

  return (
    <LayoutV1>
      <div className="page-content messages-page py-4 px-2">
        <div
          className={`messaging-shell ${
            activeId ? "messaging-shell--active" : ""
          }`}
        >
          <aside className="messaging-shell__list">
            <Chatrooms history={props.history} activeId={activeId} />
          </aside>

          <main className="messaging-shell__conversation">
            {activeId ? (
              <Messaging
                key={activeId}
                match={props.match}
                location={props.location}
                history={props.history}
              />
            ) : (
              <div className="conversation-empty">
                <div className="conversation-empty__icon">
                  <i className="fa fa-comments-o" />
                </div>
                <h3>Sohbetleriniz</h3>
                <p>Görüntülemek için soldan bir sohbet seçin.</p>
              </div>
            )}
          </main>
        </div>
      </div>
    </LayoutV1>
  );
}

export default MessagingShell;
